/**
 * Copyright (C) 2020, Merkur India.
 *
 * The program(s) herein may be used and/or copied only with
 * the written permission of Merkur India. or in accordance with
 * the terms and conditions stipulated in the agreement/contract
 * under which the program(s) have been supplied.
 *
 * $Id: BSWinLine.ts ,v 1.0 Exp $
 * Date Author Changes
 * 3 July 2020 Sujata Nethani Created
 *
 */
namespace WinAnimation.Line {
    /**
  * WinLine class is used to handle all common mehtods for desktop and mobile versions
  * @author <a href=mailto:snethani@gauselmann.com>Sujata Nethani</a>
  * @version $Revision: 1.0 $ $Date:  3 July 2020 $
  */
    export class BSWinLine extends WinLine {
        constructor(id: number, lineGraphic?: PIXI.DisplayObject) {
            super(id, lineGraphic);
        }
        hideTags(): void {
            // Override to stop hiding tags
        }
    }
}